import { FC } from "react";
import { IconPropsType } from ".";

export const Transaction: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.75 11V11C1.75 12.1046 2.64543 13 3.75 13H11.75C12.8546 13 13.75 12.1046 13.75 11V5.5C13.75 4.39543 12.8546 3.5 11.75 3.5H9"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.5 6.25001C9.08579 6.25001 8.75 6.58579 8.75 7.00001C8.75 7.41422 9.08579 7.75001 9.5 7.75001L9.5 6.25001ZM13.75 6.25L9.5 6.25001L9.5 7.75001L13.75 7.75L13.75 6.25Z"
        fill={props.color}
      />
      <circle cx="4" cy="6" r="3.25" stroke={props.color} strokeWidth="1.5" />
      <path
        d="M3 7L4 6V4.5"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
